import { render, staticRenderFns } from "./LoginWap.vue?vue&type=template&id=42d5a9e5&scoped=true&"
import script from "./LoginWap.vue?vue&type=script&lang=js&"
export * from "./LoginWap.vue?vue&type=script&lang=js&"
import style0 from "./LoginWap.vue?vue&type=style&index=0&id=42d5a9e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d5a9e5",
  null
  
)

export default component.exports